(() => {
  if (customElements.get('coffee-comparison')) return;

  class CoffeeComparison extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.narrow = window.matchMedia('(max-width: 1023px)');
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.tabs = this.querySelector('[data-tabs]');
      this.status = this.querySelector('[data-compare-status]');
      this.animations = [];
      this.querySelector('[data-compare-controls]').hidden = false;
      this.dataset.ready = 'true';
      this.addEventListener('change', this.onChange, { signal: this.controller.signal });
      this.motion.addEventListener('change', this.stopMotion, { signal: this.controller.signal });
      this.narrow.addEventListener('change', this.onViewport, { signal: this.controller.signal });
      this.syncColumns();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.stopMotion();
    }

    stopMotion = () => {
      this.animations?.forEach(animation => animation.cancel());
      this.animations = [];
    };

    onViewport = () => this.syncColumns();

    syncColumns() {
      const selected = this.dataset.selected;
      this.querySelectorAll('[data-coffee]').forEach(cell => {
        if (cell.matches('label')) return;
        cell.hidden = this.narrow.matches && cell.dataset.coffee !== selected && cell.dataset.coffee !== 'market';
      });
    }

    onChange = (event) => {
      if (event.target.matches('input[type="radio"]')) {
        const selected = event.target.value;
        if (selected === this.dataset.selected) return;
        this.stopMotion();
        this.dataset.selected = selected;
        const index = this.radios.indexOf(event.target);
        this.tabs.style.setProperty('--selected-index', index);
        this.syncColumns();
        const coffeeName = event.target.nextElementSibling.textContent.trim();
        this.status.textContent = `${coffeeName} uitgelicht.`;
        if (!this.motion.matches && !document.documentElement.classList.contains('shopify-design-mode')) {
          this.querySelectorAll(`tbody [data-coffee="${selected}"]`).forEach((cell, index) => {
            this.animations.push(cell.animate(
              [{ transform: 'translateY(4px)' }, { transform: 'translateY(0)' }],
              { duration: 280, delay: Math.min(index, 3) * 24, easing: 'cubic-bezier(.2,0,0,1)' }
            ));
          });
        }
      }
      if (event.target.matches('[data-taste-only]')) {
        this.querySelectorAll('[data-detail]').forEach(row => { row.hidden = event.target.checked; });
        this.status.textContent = event.target.checked ? 'Smaak, intensiteit en herkomst zichtbaar.' : 'Alle kenmerken zichtbaar.';
      }
    };
  }

  customElements.define('coffee-comparison', CoffeeComparison);
})();
